<script lang="ts">
    
    import type { FigureName } from "../../global";
    import { i18nService } from "../../Services";
    import { i18n } from "../../Services/i18n";

    export let name: FigureName | 'bingo';

    const namesMap = {
        'line'      : 'Línea',
        'column'    : 'Columna',
        'diagonal'  : 'Diagonal',
        'corners'   : 'Esquinas',
        'bingo'     : 'Binfun',
    };

    $: text = $i18n(namesMap[name]);

</script>

<slot {text}>{text}</slot>
